import _toArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.reduce.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { TreeError } from './tree.js';
import { tail2 } from '../../../common/arrays.js';
import { Emitter, EventBufferer } from '../../../common/event.js';
import { Iterable } from '../../../common/iterator.js';
export function isFilterResult(obj) {
  return typeof obj === 'object' && 'visibility' in obj && 'data' in obj;
}
export function getVisibleState(visibility) {
  switch (visibility) {
    case true:
      return 1
      /* Visible */
      ;

    case false:
      return 0
      /* Hidden */
      ;

    default:
      return visibility;
  }
}

function isCollapsibleStateUpdate(update) {
  return typeof update.collapsible === 'boolean';
}

export var IndexTreeModel = /*#__PURE__*/function () {
  function IndexTreeModel(user, list, rootElement) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, IndexTreeModel);

    this.user = user;
    this.list = list;
    this.rootRef = [];
    this.eventBufferer = new EventBufferer();
    this._onDidChangeCollapseState = new Emitter();
    this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event);
    this._onDidChangeRenderNodeCount = new Emitter();
    this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event);
    this._onDidSplice = new Emitter();
    this.onDidSplice = this._onDidSplice.event;
    this.collapseByDefault = typeof options.collapseByDefault === 'undefined' ? false : options.collapseByDefault;
    this.filter = options.filter;
    this.autoExpandSingleChildren = typeof options.autoExpandSingleChildren === 'undefined' ? false : options.autoExpandSingleChildren;
    this.root = {
      parent: undefined,
      element: rootElement,
      children: [],
      depth: 0,
      visibleChildrenCount: 0,
      visibleChildIndex: -1,
      collapsible: false,
      collapsed: false,
      renderNodeCount: 0,
      visibility: 1
      /* Visible */
      ,
      visible: true,
      filterData: undefined
    };
  }

  _createClass(IndexTreeModel, [{
    key: "splice",
    value: function splice(location, deleteCount) {
      var _this = this,
          _parentNode$children;

      var toInsert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Iterable.empty();
      var onDidCreateNode = arguments.length > 3 ? arguments[3] : undefined;
      var onDidDeleteNode = arguments.length > 4 ? arguments[4] : undefined;

      if (location.length === 0) {
        throw new TreeError(this.user, 'Invalid tree location');
      }

      var _this$getParentNodeWi = this.getParentNodeWithListIndex(location),
          parentNode = _this$getParentNodeWi.parentNode,
          listIndex = _this$getParentNodeWi.listIndex,
          revealed = _this$getParentNodeWi.revealed,
          visible = _this$getParentNodeWi.visible;

      var treeListElementsToInsert = [];
      var nodesToInsertIterator = Iterable.map(toInsert, function (el) {
        return _this.createTreeNode(el, parentNode, parentNode.visible ? 1
        /* Visible */
        : 0
        /* Hidden */
        , revealed, treeListElementsToInsert, onDidCreateNode);
      });
      var lastIndex = location[location.length - 1]; // figure out what's the visible child start index right before the
      // splice point

      var visibleChildStartIndex = 0;

      for (var i = lastIndex; i >= 0 && i < parentNode.children.length; i--) {
        var child = parentNode.children[i];

        if (child.visible) {
          visibleChildStartIndex = child.visibleChildIndex;
          break;
        }
      }

      var nodesToInsert = [];
      var insertedVisibleChildrenCount = 0;
      var renderNodeCount = 0;

      var _iterator = _createForOfIteratorHelper(nodesToInsertIterator),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _child2 = _step.value;
          nodesToInsert.push(_child2);
          renderNodeCount += _child2.renderNodeCount;

          if (_child2.visible) {
            _child2.visibleChildIndex = visibleChildStartIndex + insertedVisibleChildrenCount++;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var deletedNodes = (_parentNode$children = parentNode.children).splice.apply(_parentNode$children, [lastIndex, deleteCount].concat(nodesToInsert)); // figure out what is the count of deleted visible children


      var deletedVisibleChildrenCount = 0;

      var _iterator2 = _createForOfIteratorHelper(deletedNodes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _child3 = _step2.value;

          if (_child3.visible) {
            deletedVisibleChildrenCount++;
          }
        } // and adjust for all visible children after the splice point

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (deletedVisibleChildrenCount !== 0) {
        for (var _i = lastIndex + nodesToInsert.length; _i < parentNode.children.length; _i++) {
          var _child = parentNode.children[_i];

          if (_child.visible) {
            _child.visibleChildIndex -= deletedVisibleChildrenCount;
          }
        }
      } // update parent's visible children count


      parentNode.visibleChildrenCount += insertedVisibleChildrenCount - deletedVisibleChildrenCount;

      if (revealed && visible) {
        var visibleDeleteCount = deletedNodes.reduce(function (r, node) {
          return r + (node.visible ? node.renderNodeCount : 0);
        }, 0);

        this._updateAncestorsRenderNodeCount(parentNode, renderNodeCount - visibleDeleteCount);

        this.list.splice(listIndex, visibleDeleteCount, treeListElementsToInsert);
      }

      if (deletedNodes.length > 0 && onDidDeleteNode) {
        var visit = function visit(node) {
          onDidDeleteNode(node);
          node.children.forEach(visit);
        };

        deletedNodes.forEach(visit);
      }

      this._onDidSplice.fire({
        insertedNodes: nodesToInsert,
        deletedNodes: deletedNodes
      });

      var node = parentNode;

      while (node) {
        if (node.visibility === 2
        /* Recurse */
        ) {
          this.refilter();
          break;
        }

        node = node.parent;
      }
    }
  }, {
    key: "rerender",
    value: function rerender(location) {
      if (location.length === 0) {
        throw new TreeError(this.user, 'Invalid tree location');
      }

      var _this$getTreeNodeWith = this.getTreeNodeWithListIndex(location),
          node = _this$getTreeNodeWith.node,
          listIndex = _this$getTreeNodeWith.listIndex,
          revealed = _this$getTreeNodeWith.revealed;

      if (node.visible && revealed) {
        this.list.splice(listIndex, 1, [node]);
      }
    }
  }, {
    key: "has",
    value: function has(location) {
      return this.hasTreeNode(location);
    }
  }, {
    key: "getListIndex",
    value: function getListIndex(location) {
      var _this$getTreeNodeWith2 = this.getTreeNodeWithListIndex(location),
          listIndex = _this$getTreeNodeWith2.listIndex,
          visible = _this$getTreeNodeWith2.visible,
          revealed = _this$getTreeNodeWith2.revealed;

      return visible && revealed ? listIndex : -1;
    }
  }, {
    key: "getListRenderCount",
    value: function getListRenderCount(location) {
      return this.getTreeNode(location).renderNodeCount;
    }
  }, {
    key: "isCollapsible",
    value: function isCollapsible(location) {
      return this.getTreeNode(location).collapsible;
    }
  }, {
    key: "setCollapsible",
    value: function setCollapsible(location, collapsible) {
      var _this2 = this;

      var node = this.getTreeNode(location);

      if (typeof collapsible === 'undefined') {
        collapsible = !node.collapsible;
      }

      var update = {
        collapsible: collapsible
      };
      return this.eventBufferer.bufferEvents(function () {
        return _this2._setCollapseState(location, update);
      });
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(location) {
      return this.getTreeNode(location).collapsed;
    }
  }, {
    key: "setCollapsed",
    value: function setCollapsed(location, collapsed, recursive) {
      var _this3 = this;

      var node = this.getTreeNode(location);

      if (typeof collapsed === 'undefined') {
        collapsed = !node.collapsed;
      }

      var update = {
        collapsed: collapsed,
        recursive: recursive || false
      };
      return this.eventBufferer.bufferEvents(function () {
        return _this3._setCollapseState(location, update);
      });
    }
  }, {
    key: "_setCollapseState",
    value: function _setCollapseState(location, update) {
      var _this$getTreeNodeWith3 = this.getTreeNodeWithListIndex(location),
          node = _this$getTreeNodeWith3.node,
          listIndex = _this$getTreeNodeWith3.listIndex,
          revealed = _this$getTreeNodeWith3.revealed;

      var result = this._setListNodeCollapseState(node, listIndex, revealed, update);

      if (node !== this.root && this.autoExpandSingleChildren && result && !isCollapsibleStateUpdate(update) && node.collapsible && !node.collapsed && !update.recursive) {
        var onlyVisibleChildIndex = -1;

        for (var i = 0; i < node.children.length; i++) {
          var child = node.children[i];

          if (child.visible) {
            if (onlyVisibleChildIndex > -1) {
              onlyVisibleChildIndex = -1;
              break;
            } else {
              onlyVisibleChildIndex = i;
            }
          }
        }

        if (onlyVisibleChildIndex > -1) {
          this._setCollapseState([].concat(_toConsumableArray(location), [onlyVisibleChildIndex]), update);
        }
      }

      return result;
    }
  }, {
    key: "_setListNodeCollapseState",
    value: function _setListNodeCollapseState(node, listIndex, revealed, update) {
      var result = this._setNodeCollapseState(node, update, false);

      if (!revealed || !node.visible || !result) {
        return result;
      }

      var previousRenderNodeCount = node.renderNodeCount;
      var toInsert = this.updateNodeAfterCollapseChange(node);
      var deleteCount = previousRenderNodeCount - (listIndex === -1 ? 0 : 1);
      this.list.splice(listIndex + 1, deleteCount, toInsert.slice(1));
      return result;
    }
  }, {
    key: "_setNodeCollapseState",
    value: function _setNodeCollapseState(node, update, deep) {
      var result;

      if (node === this.root) {
        result = false;
      } else {
        if (isCollapsibleStateUpdate(update)) {
          result = node.collapsible !== update.collapsible;
          node.collapsible = update.collapsible;
        } else if (!node.collapsible) {
          result = false;
        } else {
          result = node.collapsed !== update.collapsed;
          node.collapsed = update.collapsed;
        }

        if (result) {
          this._onDidChangeCollapseState.fire({
            node: node,
            deep: deep
          });
        }
      }

      if (!isCollapsibleStateUpdate(update) && update.recursive) {
        var _iterator3 = _createForOfIteratorHelper(node.children),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var child = _step3.value;
            result = this._setNodeCollapseState(child, update, true) || result;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return result;
    }
  }, {
    key: "expandTo",
    value: function expandTo(location) {
      var _this4 = this;

      this.eventBufferer.bufferEvents(function () {
        var node = _this4.getTreeNode(location);

        while (node.parent) {
          node = node.parent;
          location = location.slice(0, location.length - 1);

          if (node.collapsed) {
            _this4._setCollapseState(location, {
              collapsed: false,
              recursive: false
            });
          }
        }
      });
    }
  }, {
    key: "refilter",
    value: function refilter() {
      var previousRenderNodeCount = this.root.renderNodeCount;
      var toInsert = this.updateNodeAfterFilterChange(this.root);
      this.list.splice(0, previousRenderNodeCount, toInsert);
    }
  }, {
    key: "createTreeNode",
    value: function createTreeNode(treeElement, parent, parentVisibility, revealed, treeListElements, onDidCreateNode) {
      var _this5 = this;

      var node = {
        parent: parent,
        element: treeElement.element,
        children: [],
        depth: parent.depth + 1,
        visibleChildrenCount: 0,
        visibleChildIndex: -1,
        collapsible: typeof treeElement.collapsible === 'boolean' ? treeElement.collapsible : typeof treeElement.collapsed !== 'undefined',
        collapsed: typeof treeElement.collapsed === 'undefined' ? this.collapseByDefault : treeElement.collapsed,
        renderNodeCount: 1,
        visibility: 1
        /* Visible */
        ,
        visible: true,
        filterData: undefined
      };

      var visibility = this._filterNode(node, parentVisibility);

      node.visibility = visibility;

      if (revealed) {
        treeListElements.push(node);
      }

      var childElements = treeElement.children || Iterable.empty();
      var childRevealed = revealed && visibility !== 0
      /* Hidden */
      && !node.collapsed;
      var childNodes = Iterable.map(childElements, function (el) {
        return _this5.createTreeNode(el, node, visibility, childRevealed, treeListElements, onDidCreateNode);
      });
      var visibleChildrenCount = 0;
      var renderNodeCount = 1;

      var _iterator4 = _createForOfIteratorHelper(childNodes),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          node.children.push(child);
          renderNodeCount += child.renderNodeCount;

          if (child.visible) {
            child.visibleChildIndex = visibleChildrenCount++;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      node.collapsible = node.collapsible || node.children.length > 0;
      node.visibleChildrenCount = visibleChildrenCount;
      node.visible = visibility === 2
      /* Recurse */
      ? visibleChildrenCount > 0 : visibility === 1
      /* Visible */
      ;

      if (!node.visible) {
        node.renderNodeCount = 0;

        if (revealed) {
          treeListElements.pop();
        }
      } else if (!node.collapsed) {
        node.renderNodeCount = renderNodeCount;
      }

      if (onDidCreateNode) {
        onDidCreateNode(node);
      }

      return node;
    }
  }, {
    key: "updateNodeAfterCollapseChange",
    value: function updateNodeAfterCollapseChange(node) {
      var previousRenderNodeCount = node.renderNodeCount;
      var result = [];

      this._updateNodeAfterCollapseChange(node, result);

      this._updateAncestorsRenderNodeCount(node.parent, result.length - previousRenderNodeCount);

      return result;
    }
  }, {
    key: "_updateNodeAfterCollapseChange",
    value: function _updateNodeAfterCollapseChange(node, result) {
      if (node.visible === false) {
        return 0;
      }

      result.push(node);
      node.renderNodeCount = 1;

      if (!node.collapsed) {
        var _iterator5 = _createForOfIteratorHelper(node.children),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var child = _step5.value;
            node.renderNodeCount += this._updateNodeAfterCollapseChange(child, result);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      this._onDidChangeRenderNodeCount.fire(node);

      return node.renderNodeCount;
    }
  }, {
    key: "updateNodeAfterFilterChange",
    value: function updateNodeAfterFilterChange(node) {
      var previousRenderNodeCount = node.renderNodeCount;
      var result = [];

      this._updateNodeAfterFilterChange(node, node.visible ? 1
      /* Visible */
      : 0
      /* Hidden */
      , result);

      this._updateAncestorsRenderNodeCount(node.parent, result.length - previousRenderNodeCount);

      return result;
    }
  }, {
    key: "_updateNodeAfterFilterChange",
    value: function _updateNodeAfterFilterChange(node, parentVisibility, result) {
      var revealed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var visibility;

      if (node !== this.root) {
        visibility = this._filterNode(node, parentVisibility);

        if (visibility === 0
        /* Hidden */
        ) {
          node.visible = false;
          node.renderNodeCount = 0;
          return false;
        }

        if (revealed) {
          result.push(node);
        }
      }

      var resultStartLength = result.length;
      node.renderNodeCount = node === this.root ? 0 : 1;
      var hasVisibleDescendants = false;

      if (!node.collapsed || visibility !== 0
      /* Hidden */
      ) {
        var visibleChildIndex = 0;

        var _iterator6 = _createForOfIteratorHelper(node.children),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var child = _step6.value;
            hasVisibleDescendants = this._updateNodeAfterFilterChange(child, visibility, result, revealed && !node.collapsed) || hasVisibleDescendants;

            if (child.visible) {
              child.visibleChildIndex = visibleChildIndex++;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        node.visibleChildrenCount = visibleChildIndex;
      } else {
        node.visibleChildrenCount = 0;
      }

      if (node !== this.root) {
        node.visible = visibility === 2
        /* Recurse */
        ? hasVisibleDescendants : visibility === 1
        /* Visible */
        ;
      }

      if (!node.visible) {
        node.renderNodeCount = 0;

        if (revealed) {
          result.pop();
        }
      } else if (!node.collapsed) {
        node.renderNodeCount += result.length - resultStartLength;
      }

      this._onDidChangeRenderNodeCount.fire(node);

      return node.visible;
    }
  }, {
    key: "_updateAncestorsRenderNodeCount",
    value: function _updateAncestorsRenderNodeCount(node, diff) {
      if (diff === 0) {
        return;
      }

      while (node) {
        node.renderNodeCount += diff;

        this._onDidChangeRenderNodeCount.fire(node);

        node = node.parent;
      }
    }
  }, {
    key: "_filterNode",
    value: function _filterNode(node, parentVisibility) {
      var result = this.filter ? this.filter.filter(node.element, parentVisibility) : 1
      /* Visible */
      ;

      if (typeof result === 'boolean') {
        node.filterData = undefined;
        return result ? 1
        /* Visible */
        : 0
        /* Hidden */
        ;
      } else if (isFilterResult(result)) {
        node.filterData = result.data;
        return getVisibleState(result.visibility);
      } else {
        node.filterData = undefined;
        return getVisibleState(result);
      }
    } // cheap

  }, {
    key: "hasTreeNode",
    value: function hasTreeNode(location) {
      var node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root;

      if (!location || location.length === 0) {
        return true;
      }

      var _location = _toArray(location),
          index = _location[0],
          rest = _location.slice(1);

      if (index < 0 || index > node.children.length) {
        return false;
      }

      return this.hasTreeNode(rest, node.children[index]);
    } // cheap

  }, {
    key: "getTreeNode",
    value: function getTreeNode(location) {
      var node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root;

      if (!location || location.length === 0) {
        return node;
      }

      var _location2 = _toArray(location),
          index = _location2[0],
          rest = _location2.slice(1);

      if (index < 0 || index > node.children.length) {
        throw new TreeError(this.user, 'Invalid tree location');
      }

      return this.getTreeNode(rest, node.children[index]);
    } // expensive

  }, {
    key: "getTreeNodeWithListIndex",
    value: function getTreeNodeWithListIndex(location) {
      if (location.length === 0) {
        return {
          node: this.root,
          listIndex: -1,
          revealed: true,
          visible: false
        };
      }

      var _this$getParentNodeWi2 = this.getParentNodeWithListIndex(location),
          parentNode = _this$getParentNodeWi2.parentNode,
          listIndex = _this$getParentNodeWi2.listIndex,
          revealed = _this$getParentNodeWi2.revealed,
          visible = _this$getParentNodeWi2.visible;

      var index = location[location.length - 1];

      if (index < 0 || index > parentNode.children.length) {
        throw new TreeError(this.user, 'Invalid tree location');
      }

      var node = parentNode.children[index];
      return {
        node: node,
        listIndex: listIndex,
        revealed: revealed,
        visible: visible && node.visible
      };
    }
  }, {
    key: "getParentNodeWithListIndex",
    value: function getParentNodeWithListIndex(location) {
      var node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root;
      var listIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var revealed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var visible = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      var _location3 = _toArray(location),
          index = _location3[0],
          rest = _location3.slice(1);

      if (index < 0 || index > node.children.length) {
        throw new TreeError(this.user, 'Invalid tree location');
      } // TODO@joao perf!


      for (var i = 0; i < index; i++) {
        listIndex += node.children[i].renderNodeCount;
      }

      revealed = revealed && !node.collapsed;
      visible = visible && node.visible;

      if (rest.length === 0) {
        return {
          parentNode: node,
          listIndex: listIndex,
          revealed: revealed,
          visible: visible
        };
      }

      return this.getParentNodeWithListIndex(rest, node.children[index], listIndex + 1, revealed, visible);
    }
  }, {
    key: "getNode",
    value: function getNode() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.getTreeNode(location);
    } // TODO@joao perf!

  }, {
    key: "getNodeLocation",
    value: function getNodeLocation(node) {
      var location = [];
      var indexTreeNode = node; // typing woes

      while (indexTreeNode.parent) {
        location.push(indexTreeNode.parent.children.indexOf(indexTreeNode));
        indexTreeNode = indexTreeNode.parent;
      }

      return location.reverse();
    }
  }, {
    key: "getParentNodeLocation",
    value: function getParentNodeLocation(location) {
      if (location.length === 0) {
        return undefined;
      } else if (location.length === 1) {
        return [];
      } else {
        return tail2(location)[0];
      }
    }
  }]);

  return IndexTreeModel;
}();